import React, { useEffect, useState } from "react";
import image2 from "../src/Ndirectors/1. S R Sathishchandra.jpg";
import image3 from "../src/Ndirectors/2. Umesh Prabhu K.jpg";
import image4 from "../src/Ndirectors/3. Rajagopala B.jpg";
import image5 from "../src/Ndirectors/4. Harish Borker K.jpg";
import image6 from "../src/Ndirectors/5. B Vasanth Shankar.jpg";
import image8 from "../src/Ndirectors/6. Raveesh P.jpg";
import image10 from "../src/Ndirectors/7. Vedavyas K.jpg";
import image11 from "../src/Ndirectors/8. Chandrashekara Bhat M.jpg";
import image12 from "../src/Ndirectors/9. Dayananda Nayak K.jpg";
import image13 from "../src/Ndirectors/10. K Sanjeeva Nayak.jpg";
import image14 from "../src/Ndirectors/11. Devaki K.jpg";
import image16 from "../src/Ndirectors/12. Ranjitha R Prabhu.jpg";
import  image17 from "../src/Ndirectors/Pushpalataha N.jpg";
import image18 from "../src/Ndirectors/Ananthakrishna B.jpg";

import image19 from "../src/Ndirectors/vasantha A.jpeg";


import ssp1 from "../src/assets/ssp.png";
import Navbar from "./Navbar";
import Footer from "./Footer";

const directorsData = [
  { name: "Sri S R Sathischandra", title: "President", image: image2 },
  { name: "Shri Umesh Prabhu K", title: "Vice President", image: image3 },
  { name: "Shri Rajagopala B", title: "Director", image: image4 },
  { name: "Shri Harish Borkar K", title: "Director", image: image5 },
  { name: "Shri B Vasantha Shankar", title: "Director", image: image6 },
  { name: "Shri Raveesh P", title: "Director", image: image8 },
  { name: "Shri Vedavyasa K", title: "Director", image: image10 },
  { name: "Shri Chandrashekhara Bhat M", title: "Director", image: image11 },
  { name: "Shri Dayananda Nayak K", title: "Director", image: image12 },
  { name: "Shri K Sanjeeva Nayak", title: "Director", image: image13 },
  { name: "Shrimathi Devaki K", title: "Director", image: image14 },
  { name: "Shrimathi Ranjitha R Prabhu", title: "Director", image: image16 },
  { name: "Smt. Pushpalatha N Rtd. Sr. Manager Union Bank Of India", title: "Professional Director", image: image17 },
  { name: "Shri. Ananthakrishna B Rtd. CEO Mandekolu PACS", title: "Professional Director", image: image18 },
  { name: "Shri vasantha Nayak A", title: "CEO", image: image19 },
];

const Directors = () => {
  const [columns, setColumns] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1200) {
        setColumns(5); // more cards per row on large screens
      } else if (window.innerWidth >= 1024) {
        setColumns(4);
      } else if (window.innerWidth >= 768) {
        setColumns(3);
      } else if (window.innerWidth >= 640) {
        setColumns(2);
      } else {
        setColumns(1);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Navbar />

      <div className="small-container">
        <div className="small-sidebar">
          <div className="sidebar-wave-top"></div>
          <ul>
            <li><a href="presidents_message">President's Message</a></li>
            <li><a href="documents">Annual Report</a></li>
            <li><a href="interest">Interest Rate</a></li>
            <li><a href="loans">Loans</a></li>
            <li><a href="awards">Awards</a></li>
          </ul>
          <div className="sidebar-wave"></div>
        </div>

        <div className="small-content">
          <div className="image-wrapper">
            <img
              src={ssp1}
              alt="About Us"
              style={{ width: "100%", maxHeight: "280px", objectFit: "cover" }}
            />
          </div>
        </div>
      </div>

      {/* Directors Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: "15px",
          padding: "20px",
          background: "linear-gradient(90deg, #fff, #cb71ca)",
        }}
      >
        {directorsData.map((director, index) => (
          <div
            key={index}
            style={{
              boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
              borderRadius: "8px",
              textAlign: "center",
              padding: "10px",
              backgroundColor: "#ffffff",
              minHeight: "340px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <img
              src={director.image}
              alt={director.name}
              style={{
                width: "100%",
                height: "160px",
                objectFit: "contain",
                marginBottom: "10px",
                borderRadius: "6px",
                border: "1px solid #e0e0e0",
              }}
            />
            <h3
              style={{
                margin: "6px 0",
                color: "#4a4a4a",
                fontSize: "15px",
              }}
            >
              {director.name}
            </h3>
            <p
              style={{
                fontWeight: "bold",
                margin: "4px 0",
                fontSize: "14px",
              }}
            >
              {director.title}
            </p>
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default Directors;
